/* eslint-disable max-len */
import React from 'react';

const D9THCIcon = (props) => (
  <svg width='79' height='44' viewBox='0 0 79 44' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M24.1729 21.2624V16.0742H23.0606V18.1121H20.6104V16.0742H19.5059V21.2624H20.6104V19.0767H23.0606V21.2624H24.1729Z'
      fill='#4F5D68'
    />
    <path
      d='M6.17285 32.2624V27.0742H5.06055V29.1121H2.61038V27.0742H1.50586V32.2624H2.61038V30.0767H5.06055V32.2624H6.17285Z'
      fill='#4F5D68'
    />
    <path
      d='M16.9289 41.1797C18.3126 41.1797 19.3246 40.1884 19.3246 38.8047C19.3246 37.421 18.3126 36.4297 16.9289 36.4297C15.5383 36.4297 14.5264 37.421 14.5264 38.8047C14.5264 40.1884 15.5383 41.1797 16.9289 41.1797ZM16.9289 40.3123C16.0753 40.3123 15.5314 39.6583 15.5314 38.8047C15.5314 37.9442 16.0753 37.2971 16.9289 37.2971C17.7756 37.2971 18.3195 37.9442 18.3195 38.8047C18.3195 39.6583 17.7756 40.3123 16.9289 40.3123Z'
      fill='#4F5D68'
    />
    <path
      d='M32.8671 16.2906C34.2455 16.2906 35.2536 15.303 35.2536 13.9246C35.2536 12.5461 34.2455 11.5586 32.8671 11.5586C31.4817 11.5586 30.4736 12.5461 30.4736 13.9246C30.4736 15.303 31.4817 16.2906 32.8671 16.2906ZM32.8671 15.4265C32.0167 15.4265 31.4749 14.775 31.4749 13.9246C31.4749 13.0673 32.0167 12.4227 32.8671 12.4227C33.7106 12.4227 34.2524 13.0673 34.2524 13.9246C34.2524 14.775 33.7106 15.4265 32.8671 15.4265Z'
      fill='#4F5D68'
    />
    <path
      d='M40.0518 16.2083V11.634H39.0711V13.4308H36.9108V11.634H35.937V16.2083H36.9108V14.2812H39.0711V16.2083H40.0518Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.5277 12.3001L10.4268 8.45872V0.554688H8.42685V8.45872L1.32603 12.3001L0.801847 12.5837V13.1797V22.1797V22.7507L1.29359 23.0409L8.42685 27.2507V34.6127L0.875179 34.0574L0.728516 36.052L7.63292 36.5597L4.4375 42.0518L6.1662 43.0576L9.69417 36.9939L13.3546 38.8241L14.2491 37.0353L10.4268 35.1242V27.2507L17.0599 23.3361L23.9268 27.26V35.0541L19.8644 37.0305L20.7393 38.8289L24.871 36.8189L31.5286 40.9069L32.0266 41.2127L32.5375 40.9288L39.9148 36.8303L46.923 40.9185L47.4187 41.2076L47.9184 40.9255L55.1728 36.8303L62.3042 40.9221L62.7978 41.2053L63.2934 40.9255L70.5394 36.835L77.4166 40.9147L78.437 39.1946L71.062 34.8196L70.5643 34.5243L70.0603 34.8089L62.8059 38.9041L55.6745 34.8123L55.1809 34.5291L54.6852 34.8089L47.435 38.9017L40.9268 35.1053V26.6797V26.0994L40.423 25.8114L33.0518 21.5994V17.4297H31.0518V21.6285L24.9011 25.5132L18.0518 21.5994V13.1797V12.5837L17.5277 12.3001ZM16.0518 21.6087L9.42685 25.5185L2.80185 21.6087V13.7757L9.42685 10.1916L16.0518 13.7757V21.6087ZM25.9268 35.1202V27.2309L32.0776 23.3462L38.9268 27.26V35.0913L32.0771 38.8967L25.9268 35.1202Z'
      fill='#64737F'
    />
  </svg>
);
export default D9THCIcon;
